import SetPasswordAfterUpgrade from './SetPasswordAfterUpgrade';

export default SetPasswordAfterUpgrade;
